// src/helper/Countdown.js

export const getCountdown = (endAt) => {
  if (!endAt) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
  }

  // supports: "2026-02-02 13:30:00" OR ISO
  const end = new Date(String(endAt).replace(" ", "T"));
  const now = new Date();

  let diff = end.getTime() - now.getTime();
  if (isNaN(end.getTime()) || diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * (1000 * 60 * 60 * 24);

  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * (1000 * 60 * 60);

  const minutes = Math.floor(diff / (1000 * 60));
  diff -= minutes * (1000 * 60);

  const seconds = Math.floor(diff / 1000);

  return {
    days,
    hours,
    minutes,
    seconds,
    isExpired: false,
  };
};
